import React from 'react';
import { Typography } from '@mui/material';
import { formatCurrency } from '../../../utils/formatUtils';

type TotalDiscrepancyDisplayProps = {
  totalDiscrepancy: number | { isNA: true };
};

const TotalDiscrepancyDisplay: React.FC<TotalDiscrepancyDisplayProps> = ({ totalDiscrepancy }) => {
  if (typeof totalDiscrepancy === 'object' && 'isNA' in totalDiscrepancy) {
    return <span style={{ color: '#666' }} title="No data available">-</span>;
  }

  const isPositive = totalDiscrepancy > 0;
  const displayValue = `${totalDiscrepancy > 0 ? '+' : ''}${formatCurrency(totalDiscrepancy)}`;
  const title = totalDiscrepancy === 0 ? 'All audits matched' : `Total discrepancy: ${displayValue}`;

  if (isPositive) {
    return (
      <Typography
        variant="body2"
        sx={{ color: '#0000FF', fontWeight: 400, fontSize: '14px' }}
        title={title}
      >
        {displayValue}
      </Typography>
    );
  }

  return (
    <Typography
      variant="body2"
      sx={{ color: totalDiscrepancy === 0 ? 'green' : 'red', fontWeight: 400, fontSize: '14px' }}
      title={title}
    >
      {totalDiscrepancy === 0 ? <span style={{ color: 'green', fontSize: '32px' }}>&#10003;</span> : displayValue}
    </Typography>
  );
};

export default TotalDiscrepancyDisplay;

